<template>
  <div class="product-detail-head">
    <div class="product-detail-head_img">
      <img :src="image" class="pc-only" :alt="imageAlt" />
      <img :src="spImage || image" class="sp-only" :alt="imageAlt" />
    </div>
    <PartsLayoutContainer>
      <div class="product-detail-head-content">
        <h3 class="product-detail-name">{{ name }}</h3>
        <slot />
      </div>
    </PartsLayoutContainer>
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `product-detail-head`（商品詳細のFV＋商品名）。商品詳細38本すべてと `/set` に出る。
 *
 * **商品名は API の `product.name`**（`GET /api/v1/front/products/{code}` は38/38で値を返す）。
 * FV画像だけ PC/SP の2枚構成で、支給は `page-<コード>_fv.png` と `_fv_sp.png`
 * （`design-src/20260810/product-detail/product501.html:326-336`）。
 * ギャラリーや特徴ブロックの画像は1枚なので、2枚を持つのはここだけ。
 *
 * `alt` は既定で商品名にする。支給は全38本が `alt="商品画像"` だが、
 * どの商品かが伝わらないため（隣の `h3` と重複はするが、画像単体で意味を持たせる）。
 *
 * 中身（`product-detail-note`）はスロットで受ける。
 * → CONVERSION-GUIDE.md §3.3.1 の #2
 */
type Props = {
  /** 商品名。API の `product.name` */
  name: string;
  /** FV画像（PC）。支給は `page-<コード>_fv.png` */
  image: string;
  /** FV画像（SP）。支給は `page-<コード>_fv_sp.png`。省略時は PC 用を使う */
  spImage?: string;
  /** 画像の代替テキスト。省略時は商品名 */
  alt?: string;
};

const props = withDefaults(defineProps<Props>(), {
  spImage: '',
  alt: '',
});

const imageAlt = computed<string>(() => props.alt || props.name);
</script>
